import { useProgress } from '@react-three/drei'

export default function ModelLoader() {
  const { active, progress } = useProgress()

  return (
    <div className={`model-loader ${active ? 'model-loader--active' : ''}`} aria-live="polite">
      <div className="model-loader__brand">
        <span>MoLiKa</span>
        <strong>9bar</strong>
      </div>
      <div className="model-loader__line" aria-hidden="true">
        <span style={{ width: `${Math.max(4, progress)}%` }} />
      </div>
      <small>{Math.round(progress)}%</small>
    </div>
  )
}
